import { Injectable } from '@angular/core';
import { MOBILE_BREAKPOINT, TABLET_BREAKPOINT } from '@shared/constants/responsivity';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BreakpointObserver } from '@angular/cdk/layout';
import { BehaviorSubject } from 'rxjs';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class ResponsivityService {
  isMenuOpen = new BehaviorSubject<boolean>(false);
  isCategoriesOpen = new BehaviorSubject<boolean>(false);
  isTabletOrMobileOpen = new BehaviorSubject<boolean>(false);
  isTabletOpen = new BehaviorSubject<boolean>(false);
  isMobileOpen = new BehaviorSubject<boolean>(false);
  isTablet = false;

  constructor(private responsive: BreakpointObserver) { }

  // Track screen size, close mobile menu when desktop
  handleMenuToggle() {
    this.responsive.observe([MOBILE_BREAKPOINT, TABLET_BREAKPOINT])
      .pipe(untilDestroyed(this))
      .subscribe(result => {
        if (result.matches) {
          this.isTablet = false;
          this.isTabletOrMobileOpen.next(true);
        } else {
          this.isTablet = true;
          this.closeMenu();
          this.isTabletOrMobileOpen.next(false);
          this.changeIsCategoriesOpen(false);
        }
      });

    this.responsive.observe([TABLET_BREAKPOINT])
      .pipe(untilDestroyed(this))
      .subscribe(result => {
        this.isTabletOpen.next(result.matches);
      });

    this.responsive.observe([MOBILE_BREAKPOINT])
      .pipe(untilDestroyed(this))
      .subscribe(result => {
        this.isMobileOpen.next(result.matches);
      });
  }

  closeMenu() {
    this.isMenuOpen.next(false);
  }

  openMenu() {
    this.isMenuOpen.next(true);
  }

  changeIsCategoriesOpen(value: boolean) {
    this.isCategoriesOpen.next(value);
  }
}
